import Vue from 'vue';
import App from './App.vue';
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import MavonEditor from 'mavon-editor'
import showdown from 'showdown';

import 'mavon-editor/dist/css/index.css'
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/css/icon/iconfont.css";
import "@/assets/css/common/common.css"

Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(MavonEditor);
Vue.prototype.converter = new showdown.Converter();

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
